export const paths = [
  {
    name: 'HOME',
    to: '/',
    active: '/',
    onClick: '/',
    disabled: false
  },
  {
    name: 'ABOUT',
    to: '/about',
    active: '/about',
    onClick: 'about',
    disabled: false
  },
  {
    name: 'MAP',
    to: '/map',
    active: '/map',
    onClick: 'map',
    disabled: false
  },
  {
    name: 'DATABASE',
    to: '/database',
    active: '/database',
    onClick: 'database',
    disabled: false
  },
  {
    name: 'BRAVE FAIR',
    to: '/braveFair',
    active: '/braveFair',
    onClick: 'braveFair',
    disabled: false
  },
  {
    name: 'TRAINING',
    to: '/training',
    active: '/training',
    onClick: 'training',
    disabled: false
  },
  {
    name: 'TOOLKIT',
    to: '/toolkit',
    active: '/toolkit',
    onClick: 'toolkit',
    disabled: false
  },
  {
    name: 'PUBLICATIONS',
    to: '/publications',
    active: '/publications',
    onClick: 'publications',
    disabled: false
  }
]



// WEBPACK FOOTER //
// ./src/layouts/Layout/paths.js